import React, { memo, useCallback } from 'react';
import Message from './Message';
import { generateMessageId, isMessageStreaming } from '../utils/messageHelpers';
import { AGENT_STATUS } from '../constants';

/**
 * MessageList component
 * Container for rendering all messages in the chat
 */
const MessageList = memo(({ 
  validMessages, 
  copiedMessageId, 
  copyToClipboard, 
  expandedTools, 
  toggleToolExpansion, 
  agentStatus, 
  searchQuery, 
  activeSearchResult 
}) => {
  const isStreaming = useCallback((message) => {
    return isMessageStreaming(message, agentStatus);
  }, [agentStatus]);

  return (
    <div className="p-4 space-y-4">
      {validMessages.map((message, index) => {
        const messageId = generateMessageId(index, message);
        const isHighlighted = activeSearchResult && activeSearchResult.messageIndex === index;
        
        return (
          <Message
            key={messageId}
            message={message}
            index={index}
            messageId={messageId}
            copiedMessageId={copiedMessageId}
            copyToClipboard={copyToClipboard}
            isStreaming={isStreaming(message)}
            expandedTools={expandedTools}
            toggleToolExpansion={toggleToolExpansion}
            searchQuery={searchQuery}
            isHighlighted={isHighlighted}
          />
        );
      })}
    </div>
  );
});

MessageList.displayName = 'MessageList';

export default MessageList;